/**
 * SDK enums, extracted from BayunCore.js.
 *
 * These live in their own module so that utility and REST modules can read them without importing
 * BayunCore. BayunCore assigns `window.BayunCore` and injects a script tag at module load, so any
 * import of it drags DOM globals into the importer — which made `util/Utility.js` unusable outside
 * a browser and created a util -> BayunCore -> util import cycle. BayunCore re-exports these, so
 * the public SDK surface is unchanged.
 */

/**
 * This enum represents the encryption policy to be used for encryption/decryption.
 */
export const EncryptionPolicy = {
  NONE: 0,
  DEFAULT: 1,
  ORG: 2,
  MEMBER: 3,
  GROUP: 4,
  GROUP_ASYMMETRIC: 5,
};
Object.freeze(EncryptionPolicy);

/**
 * This enum represents the key generation policy to be used for encryption/decryption.
 */
export const KeyGenerationPolicy = {
  DEFAULT: 0,
  STATIC: 1,
  ENVELOPE: 2,
  CHAIN: 3,
};
Object.freeze(KeyGenerationPolicy);

/**
 * This enum represents the encryption mode to be used for encryption/decryption.
 */
export const EncryptionMode = {
  CBC: 0,
  ECB: 1,
  // CBC_HMAC: 2,
  AES_GCM: 2,
};
Object.freeze(EncryptionMode);

/**
 * This enum represents how locally stored SDK data is protected.
 */
export const LocalDataEncryptionMode = {
  SESSION_MODE: 0,
  EXPLICIT_LOGOUT_MODE: 1,
};
Object.freeze(LocalDataEncryptionMode);
